import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const patientServiceTermKeys = createQueryKeyStore({
  serviceTerm: {
    current: null,
  },
});
